// extracted by mini-css-extract-plugin
export default {"secondMenuItem":"SecondarySubMenuItems_secondMenuItem--LNp","subItems":"SecondarySubMenuItems_subItems--xLg"};